import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: theme.narrowestContainerWidth,
      backgroundColor: COLORS.neutral.white,
    },
    background: {
      width: '100%',
      height: '100%',
      position: 'fixed',
      bottom: '-50%',
      left: '-50%',
      opacity: 0.6,
      background:
        'radial-gradient(58.84% 94.86% at 50% 50%, #3D7FFE 0%, #ECF2FF 62.98%, rgba(0, 0, 0, 0.00) 70%)',
      filter: 'blur(120px)',
    },
    content: {
      position: 'relative', // to be above the background
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
  { name: 'UnauthenticatedPageLayout' }
);
